import type { TrackReference } from '@livekit/components-react';

/** Map from original trackSid (embedded in trackName like `${sid}:cropped`) to cropped trackSid */
export function buildCroppedMap(tracks: TrackReference[]): Record<string, string> {
  return tracks.reduce<Record<string, string>>((acc, t) => {
    const name = t.publication?.trackName;
    const sid = t.publication?.trackSid;
    if (!name || !sid) return acc;
    if (!name.includes(':cropped')) return acc;
    const originalTrackSid = name.split(':')[0]?.trim();
    if (originalTrackSid) acc[originalTrackSid] = sid;
    return acc;
  }, {});
}

/** Prefer cropped over original: include cropped tracks; exclude originals that have a cropped counterpart */
export function selectByCroppedPreference(
  tracks: TrackReference[],
  croppedMap: Record<string, string>,
  preferUncropped: boolean,
): TrackReference[] {
  if (preferUncropped) {
    const presentSids = new Set(tracks.map((t) => t.publication?.trackSid).filter((s): s is string => !!s));
    return tracks.filter((t) => {
      const name = t.publication?.trackName || '';
      const isCropped = name.includes(':cropped');
      if (!isCropped) return true;
      const baseSid = name.split(':')[0]?.trim();
      return baseSid ? !presentSids.has(baseSid) : true;
    });
  }
  const baseSidsWithCropped = new Set(Object.keys(croppedMap));
  return tracks.filter((t) => {
    const name = t.publication?.trackName || '';
    const isCropped = name.includes(':cropped');
    if (isCropped) return true;
    const sid = t.publication?.trackSid;
    if (!sid) return false;
    return !baseSidsWithCropped.has(sid);
  });
}
